import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DistributionsService } from 'src/app/services/distributions.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-group-update',
  templateUrl: './group-update.component.html',
  styleUrls: ['./group-update.component.scss']
})
export class GroupUpdateComponent implements OnInit{

  formCampaign!: FormGroup;

  campaignName!: string;
  nombreGrupo : string = "";

  constructor(
    @Inject(MAT_DIALOG_DATA) public data:any,
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<GroupUpdateComponent>,
    private distributionS: DistributionsService
  ) { 
    this.nombreGrupo = data.nombre;
    console.log(data);
   }

  ngOnInit(): void {
    this.createFormCampaign();
  }

  createFormCampaign(){
    this.formCampaign = this.fb.group({
      id_grupo: [this.data.id_grupo],
      capturas: [this.data.capturas, [ Validators.required]],
      orientacion: [this.data.orientation, [ Validators.required]],
    });
  }

  ruSure() {
    if(this.formCampaign.invalid) { return; }
    Swal.fire({
      title: '¿Estás seguro que deseas guardar el registro? Esto afectará a todos los materiales del mismo grupo',
      icon: 'warning',
      showDenyButton: false,
      showCancelButton: true,
      confirmButtonText: `Confirmar`,
      cancelButtonText: `Cancelar`
    }).then((result) => {      
      if (result.isConfirmed) {
        this.saveCampaign();
      }
    });
  }

  saveCampaign() {
    Swal.fire({
      icon: 'info',
      title: 'Guardando...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      }
    });
    this.formCampaign.value.name = this.campaignName;
    this.distributionS.updateGroup(this.formCampaign.value.id_grupo, this.formCampaign.value.capturas, this.formCampaign.value.orientacion).subscribe(
      (result:any) => {
        if(result.message == "Success") {
          Swal.fire({
            icon: 'success',
            title: 'Guardado',
            text: 'Grupo actualizado de manera correcta'          
          }).then(() => {            
            this.dialogRef.close({ reload: false });
          });
        }
      },
      (err:any) => {
        console.log(err);
        Swal.fire({
          icon: 'error',
          title: 'Error al guardar',
          text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
        });
      }
    );
  }

  onSelectName(name: string){
    this.campaignName = name;
  }

}
